import React from 'react';

export default ({ className }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
      fill="#1E1E1E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 9.5C7.5 8.67157 8.17157 8 9 8H9.01C9.83843 8 10.51 8.67157 10.51 9.5V9.51C10.51 10.3384 9.83843 11.01 9.01 11.01H9C8.17157 11.01 7.5 10.3384 7.5 9.51V9.5Z"
      fill="#1E1E1E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 9.5C13.5 8.67157 14.1716 8 15 8H15.01C15.8384 8 16.51 8.67157 16.51 9.5V9.51C16.51 10.3384 15.8384 11.01 15.01 11.01H15C14.1716 11.01 13.5 10.3384 13.5 9.51V9.5Z"
      fill="#1E1E1E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.03435 13.1344C8.51241 12.8579 9.12414 13.0213 9.40068 13.4993C9.92091 14.3986 10.8908 15 11.9999 15C13.1091 15 14.079 14.3986 14.5992 13.4993C14.8758 13.0213 15.4875 12.8579 15.9655 13.1344C16.4436 13.411 16.607 14.0227 16.3304 14.5008C15.4674 15.9927 13.8519 17 11.9999 17C10.148 17 8.53249 15.9927 7.66947 14.5008C7.39293 14.0227 7.55629 13.411 8.03435 13.1344Z"
      fill="#1E1E1E"
    />
  </svg>
);
